// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toast {
  display: none;
  position: absolute;
  top: 100px;
  left: 85%;
  padding: 20px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.05);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  color: white;
}

#copy-btn svg {
  /* float: right !important; */
  /* margin: 0.1rem; */
}

#toast.show-toast {
  display: inline-block;
}

.show-toast {
  animation: showToast 0.3s ease-out;
}

.hide-toast {
  animation: hideToast 0.3s ease-in;
}

@keyframes showToast {
  from {
    top: 170px;
    opacity: 0;
  }
  to {
    top: 100px;
    opacity: 1;
  }
}

@keyframes hideToast {
  from {
    top: 100px;
    opacity: 1;
  }
  to {
    top: 20px;
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/pages/copy-to-clipboard-icon.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF","sourcesContent":["#toast {\r\n  display: none;\r\n  position: absolute;\r\n  top: 100px;\r\n  left: 85%;\r\n  padding: 20px;\r\n  border-radius: 3px;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  font-family: Montserrat, sans-serif;\r\n  font-weight: 500;\r\n  color: white;\r\n}\r\n\r\n#copy-btn svg {\r\n  /* float: right !important; */\r\n  /* margin: 0.1rem; */\r\n}\r\n\r\n#toast.show-toast {\r\n  display: inline-block;\r\n}\r\n\r\n.show-toast {\r\n  animation: showToast 0.3s ease-out;\r\n}\r\n\r\n.hide-toast {\r\n  animation: hideToast 0.3s ease-in;\r\n}\r\n\r\n@keyframes showToast {\r\n  from {\r\n    top: 170px;\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    top: 100px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes hideToast {\r\n  from {\r\n    top: 100px;\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    top: 20px;\r\n    opacity: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
